import React from "react";
import { CompanySidePanel } from "../Company/CompanySidePanel";

interface CompanyForContactSidePanelProps {
  company: server.dto.CompanyWithWorkRelation
}

export const CompanyForContactDetails = ({ company: companyWithWorkRelation }: CompanyForContactSidePanelProps) => {
  return <CompanySidePanel
    companyId={companyWithWorkRelation.company.companyId}
    trigger={<div className="side-panel-list-item hoverable flex-column">
      <div>{companyWithWorkRelation.company.name}</div>
      <div className="text-sublabel">{companyWithWorkRelation.company.cityCountry}</div>
    </div>}
  />
}